import { _ as _extends } from './_rollupPluginBabelHelpers-c7687d88.js';
import React__default from 'react';
import { NumericFormat } from 'react-number-format';
import Input from './Input.js';
import 'classnames';
import './FeedbackTooltip.js';
import 'prop-types';
import './commonPropTypes-8c108b82.js';
import './types-6e7da022.js';
import './Tooltip-6986252d.js';
import '@tippy.js/react';
import './error-6281581e.js';
import './InputIcon-0309541b.js';
import './IconRouter.js';
import './add-4a4fe5c2.js';
import './filter-a4af09e9.js';
import './loading-6cabb422.js';
import './magnifying-glass-3c43cfbb.js';
import './search-42d3c9cc.js';
import './down-f9e6ad7e.js';
import './close-thin-a9749b58.js';
import './tick-filled-fbbd6819.js';
import './helpers-f6b58b19.js';
import '@motorway/motorway-tools/typeHelpers';

/**
 * Number Format Input component renders Input component formatted with commas using
 * react-number-format https://www.npmjs.com/package/react-number-format
 */

const NumberFormatInput = props => /*#__PURE__*/React__default.createElement(Input, _extends({}, props, {
  renderInput: numberProps => {
    const {
      onValueChange,
      ...customInputProps
    } = numberProps;
    return /*#__PURE__*/React__default.createElement(NumericFormat, _extends({
      allowNegative: false,
      fixedDecimalScale: true,
      thousandSeparator: ",",
      onValueChange: ({
        formattedValue
      }) => {
        const {
          onChange
        } = customInputProps;
        if (onChange) {
          customInputProps.onChange(formattedValue);
        }
      }
    }, customInputProps));
  }
}));

export { NumberFormatInput as default };
